var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icone_phone",
    "data-name": "icone phone",
    transform: "translate(-0.11 0.39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    transform: "translate(0.11 -0.39)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5,
    cy: 26,
    rx: 26.5,
    ry: 26,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5,
    cy: 26,
    rx: 25.5,
    ry: 25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_27019",
    "data-name": "Trac\\xE9 27019",
    d: "M6,8.3A2.3,2.3,0,0,1,8.3,6h3.776a1.157,1.157,0,0,1,1.094.789l1.721,5.169a1.153,1.153,0,0,1-.576,1.4l-2.6,1.3a12.75,12.75,0,0,0,6.355,6.355l1.3-2.6a1.153,1.153,0,0,1,1.4-.576l5.169,1.721a1.157,1.157,0,0,1,.789,1.094V24.42a2.3,2.3,0,0,1-2.3,2.3H23.269A17.268,17.268,0,0,1,6,9.454Z",
    transform: "translate(10.249 9.249)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconephone);
export default __webpack_public_path__ + "static/media/icone phone.e8967a00e158edcd6216f5da9c856aa7.svg";
export { ForwardRef as ReactComponent };